export enum ProgramMenuKey {
  PROGRAM_HOME = "programHome",
  DASHBOARD = "dashboard",
  PROGRAM_ORGANIZATION = "programOrganization",
  TIMELINE_CONFIGURATION = "timelineConfiguration",
  PROFILE = "profile",
  CONFIGURATION = "configuration",
  WORKFLOW = "workflow",
  SELECTION_CONFIGURATION = "selectionConfiguration",
  SELECTION_ROUND_1 = "selection_round_1",
  SELECTION_ROUND_2 = "selection_round_2",
  SELECTION_ROUND_3 = "selection_round_3"
}
